var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue2Dropzone',{ref:"drop-zone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-removed-file":_vm.onRemovedFile}})}
var staticRenderFns = []

export { render, staticRenderFns }